import { Model as s } from "../../../model.js";
import { centsToNumber as e, formatCurrency as o } from "../../../../../utils.js";
class h extends s {
  constructor(t) {
    super(), this.currency = t.currency, this.discountAmount = t.discountAmount, this.paymentFee = t.paymentFee, this.rawServiceFee = t.rawServiceFee, this.serviceFee = t.serviceFee, this.subtotal = t.subtotal, this.taxes = t.taxes, this.taxInPrices = t.taxInPrices, this.tip = t.tip, this.total = t.total;
  }
  getSubtotal() {
    return e(this.subtotal);
  }
  getTotal() {
    return e(this.total);
  }
  getFormattedTotal() {
    return o(this.getTotal(), this.currency);
  }
}
export {
  h as TicketSummaryModel
};
//# sourceMappingURL=ticketSummary.model.js.map
